import { render, staticRenderFns } from "./ImportProductCombo.vue?vue&type=template&id=12352586&scoped=true"
import script from "./ImportProductCombo.vue?vue&type=script&lang=js"
export * from "./ImportProductCombo.vue?vue&type=script&lang=js"
import style0 from "./ImportProductCombo.vue?vue&type=style&index=0&id=12352586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12352586",
  null
  
)

export default component.exports